<div class="dialog-box">
  <div class="mat-dialog-title" mat-dialog-title>
      <div id="lblHeading">
          File View / Download Wizard
          <i class="fa fa-times-circle pull-right" (click)="togglePopupDialog()" aria-hidden="true"></i>
      </div>
  </div>
</div>
<div mat-dialog-content class="">
  <div class="row m-0 eip-pb-20">
      <div class="">
          <kendo-grid [data]="fileCollection" [resizable]="true" [pageSize]="15" id="grvFileList" [pageable]="true">
              <kendo-grid-column field="serial" title="Sl.No." [width]="60">
              </kendo-grid-column>
              <kendo-grid-column field="fileName" hidden="true"></kendo-grid-column>
              <kendo-grid-column field="fileSize" hidden="true"></kendo-grid-column>
              <kendo-grid-column field="fileExtension" hidden="true"></kendo-grid-column>
              <kendo-grid-column field="fileFullName" title="File Name" [width]="150">
                  <ng-template kendoGridCellTemplate let-dataItem>
                      <span class="no-wrap" eipTooltip="{{dataItem.fileFullName}}" eipTooltipPosition="auto">
                          {{dataItem.fileFullName}}
                      </span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="fileTypeName" title="File Type" [width]="60">
                  <ng-template kendoGridCellTemplate let-dataItem>
                      <span class="no-wrap" eipTooltip="{{dataItem.fileTypeName}}" eipTooltipPosition="auto">
                          {{dataItem.fileTypeName}}
                      </span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="uploadedBy" hidden="true"></kendo-grid-column>
              <kendo-grid-column field="uploadedByName" title="Attached By" [width]="90">
                  <ng-template kendoGridCellTemplate let-dataItem>
                      <span class="no-wrap" eipTooltip="{{dataItem.uploadedByName}}" eipTooltipPosition="auto">
                          {{dataItem.uploadedByName}}
                      </span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="uploadedOn" title="Attached On" [width]="110">
                  <ng-template kendoGridCellTemplate let-dataItem>
                      <span class="no-wrap" eipTooltip="{{dataItem.uploadedOn}}" eipTooltipPosition="auto">
                          {{dataItem.uploadedOn}}
                      </span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="libraryNumber" title="Library" width="00" hidden="true">
                  <ng-template kendoGridCellTemplate let-dataItem>
                      <span class="no-wrap" eipTooltip="{{dataItem.libraryNumber}}" eipTooltipPosition="auto">
                          {{dataItem.libraryNumber}}
                      </span>
                  </ng-template>
              </kendo-grid-column>
              <kendo-grid-column title="Actions" [width]="100">
                  <ng-template kendoGridHeaderTemplate let-column>
                      <div class="icon-container d-flex align-items-center">
                          <span>Actions</span>
                          <i class="fa fa-download" aria-hidden="true" style="cursor: pointer; font-size: 24px; margin-left: 10px;" title="Download All" (click)="downloadAll_OnClick()"></i>
                      </div>
                  </ng-template>
                  <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                      <div class="icon-container d-flex align-items-center">
                          <i class="fa fa-download icon-my-10" (click)="downloadFile(dataItem)" aria-hidden="true"  title="Download" id="btnDownload" style="font-size: 1.25em; cursor: pointer;"></i>
                          <i *ngIf="isAllowedBrowserView(dataItem)" class="fa fa-eye icon-my-10" aria-hidden="true" title="View" id="btnView" (click)="viewFile(dataItem)" style="font-size: 1.25em; cursor: pointer;"></i>
                          <i class="fa fa-trash" title="Delete" (click)="deleteFile(dataItem)" *ngIf="isDeleteEnable == true" aria-hidden="true" style="font-size: 1.25em; cursor: pointer;"></i>
                      </div>
                  </ng-template>
              </kendo-grid-column>
          </kendo-grid>
      </div>
  </div>
</div>